import { render, staticRenderFns } from "./SecurityDevice.vue?vue&type=template&id=3a5f11dd&scoped=true&"
import script from "./SecurityDevice.vue?vue&type=script&lang=js&"
export * from "./SecurityDevice.vue?vue&type=script&lang=js&"
import style0 from "./SecurityDevice.vue?vue&type=style&index=0&id=3a5f11dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5f11dd",
  null
  
)

export default component.exports